import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { TanggalHari } from './Utils'
import AccessibilityControl from './AccessibilityControl'

function Footbar() {
    const [data, setData] = useState([])
    const [showProcurement, setShowProcurement] = useState(false)
    const [latestProcurement, setLatestProcurement] = useState([])

    const loadLatestProcurements = async () => {
        try {
            // Panggil controller dengan jml=5
            const res = await axios.post('/api/procurement/publish', { jml: 5 })
            setLatestProcurement(res.data)
        } catch (err) {
            console.error("Gagal load pengadaan", err)
        }
    }

    const getData = async () => {
        const response = await axios.post("/api/publikasi/publish", {
            key: '',
            kategori: '',
            jml: 5
        })
        setData(response.data)
    }

    useEffect(() => {
        getData()
        loadLatestProcurements()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <aside className="ms-footbar mt-0 pt-2 pb-2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 ms-footer-col ms-footer-text-left">
                            <div className="ms-footbar-block">
                                <div className="ms-footbar-title">
                                    <h3 className="no-m font-bold">Semua Publikasi</h3>
                                </div>
                                <address className="no-mb">
                                    <ul className='list-unstyled ms-icon-list'>
                                        {data.map((val, index) => (
                                            <li key={index}>
                                                <hr></hr>
                                                <h5 className="no-mb">{val.kategori}</h5>
                                                <div className="row">
                                                    <div className="col-md-10">
                                                        <Link to={'/info/' + val.kategori.replaceAll(' ', '-').toLowerCase() + '/' + val.title} className="text-warning wow fadeInUp animation-delay-2">
                                                            <h4 className="mt-1 no-mb font-bold">{val.judul}</h4>
                                                        </Link>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <span className="text-right text-small font-bold"><TanggalHari value={val.tanggal} /></span>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </address>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>

            <div className={`procurement-drawer ${showProcurement ? 'open' : ''}`}>
                {/* Ikon untuk membuka */}
                {!showProcurement && (
                    <button className="procurement-btn-trigger" onClick={() => setShowProcurement(true)}>
                        <i className="fa fa-briefcase"></i>
                    </button>
                )}

                {/* Daftar Pengadaan yang muncul saat diklik */}
                {showProcurement && (
                    <div className="procurement-list">
                        <div className="header">
                            <i className="fa fa-bullhorn"></i> Peluang Kemitraan
                            <button className="btn-close" onClick={() => setShowProcurement(false)}>
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                        <div className="procurement-promo" style={{ textAlign: 'center', padding: '10px 0' }}>
                            <img src="/assets/img/procurement.png" alt="Procurement" style={{ width: '80px', marginBottom: '10px' }} />
                            <p style={{ fontSize: '13px', color: '#555', marginBottom: '15px' }}>
                                Jangan lewatkan kesempatan menjadi mitra strategis. Lihat daftar pengadaan terkini.
                            </p>
                        </div>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            {latestProcurement.map(item => (
                                <li key={item._id} style={{ borderBottom: '1px solid #eee', padding: '5px 0', textTransform: "capitalize" }}>
                                    <Link to={`/kebutuhan-pengadaan/${item.code}/${item.title.replaceAll(' ', '-').replaceAll('/', '_').toLowerCase()}`} style={{ fontSize: '13px', fontWeight: "bold" }}>{item.title}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            <AccessibilityControl />
        </>
    )
}

export default Footbar